export default __webpack_public_path__ + "static/media/gamefi_04_2.1e0fbfd3.png";